import { useEffect } from "react";
import { logger } from "../utils/logger";

export const usePageLogger = (pageName, extraData = {}) => {
  useEffect(() => {
    logger.info("Page viewed", {
      page: pageName,
      ...extraData,
    });

  }, [pageName, JSON.stringify(extraData)]);
};
